import React from 'react';
import { NavHashLink as Link } from 'react-router-hash-link';

import { JobItem } from "./JobItem"
import Form from "./Form"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import StagePO from "../jobOffers/Coddity - 2026-09 - Assistant PO - Septembre.pdf"


const Join = () => (
    <>
        <div className="section">
            <div className="content">
                <h1 className="sectiontitle"><span className="red">V</span>ocation d'Artisan ?</h1>
                
                <div className="row">
                    <p className="center pad-text">
                        Nous restons une petite équipe qui se connait bien mais sommes ouverts à toute rencontre !
                        <br />
                        <br />
                        Seul test technique : une participation à <a href="https://movaicode.fr" target="_blank" rel="noopener noreferrer">
                            <b>movaicode</b>
                        </a>
                    </p>

                    <div className="center">
                        <JobItem contract="Stage" title="Assistant PO" file={StagePO} date="Sep2026" />
                    </div>

                    <p className="center">
                        <Link to="/devenir-artisan#form" smooth duration={500} >
                            <FontAwesomeIcon size="2x" icon={faAngleDown} />
                        </Link>
                    </p>
                </div>
            </div>
        </div>

        <div id="form" className="section dark">
            <div className="content">
                <h1 className="sectiontitle"><span className="red">C</span>andidater ?</h1>
                <div className="row">
                    <p className="center">Passez nous voir dans le 11ème, écrivez-nous à contact@coddity.com ou complétez le formulaire suivant :</p>
                    <Form typeFormulaire="candidat" />
                </div>
            </div>
        </div>
    </>
);

export default Join;
